import React from "react";
import { useTranslation } from "react-i18next";

import FullScreen from "~/components/Icons/svg/fullScreen";
import { ChartBarIvideon, CircleChart } from "~/components/Chart";
import { getPercentages } from "~/pages/IvideonDealerSummary2/helper";
import { faceVariables } from "~/pages/IvideonDealerSummary2/options";

import { FaceDataBarState, LabelsType } from ".";

import styles from "~/pages/IvideonDealerSummary2/IvideonDealerSummary.less";

interface ChartsPeopleIProps {
  dataBar: FaceDataBarState;
  labels: LabelsType;
  handleVariant: (prop: string) => void;
  isLoading: boolean;
}

const ChartsPeople = ({
  dataBar,
  labels,
  handleVariant,
  isLoading,
}: ChartsPeopleIProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.wrapperGraph}>
        {dataBar &&
          labels &&
          faceVariables({ dataBar, labels }).map((item) => {
            if (item.type === "bar") {
              return (
                <div className={styles.cardGraphSmall} key={item.variant}>
                  <div className={styles.cardTitleWrapper}>
                    <span className={styles.cardTitle}>{item.title}</span>
                    <div className={styles.itemTitleWrapper}>
                      {item.variant === "gender" && (
                        <>
                          <div className={styles.itemTitle}>
                            <div className={styles.colorItemBlue}></div>
                            <span>мужчины</span>
                          </div>
                          <div className={styles.itemTitle}>
                            <div className={styles.colorItemOrange}></div>
                            <span>женщины</span>
                          </div>
                        </>
                      )}
                      {item.variant === "newFaces" && (
                        <>
                          <div className={styles.itemTitle}>
                            <div className={styles.colorItemOrange}></div>
                            <span>Уникальные</span>
                          </div>
                          <div className={styles.itemTitle}>
                            <div className={styles.colorItemGreen}></div>
                            <span>Новые</span>
                          </div>
                        </>
                      )}
                      {item.variant === "returningFaces" && (
                        <>
                          <div className={styles.itemTitle}>
                            <div className={styles.colorItemOrange}></div>
                            <span>Уникальные</span>
                          </div>
                          <div className={styles.itemTitle}>
                            <div className={styles.colorItemGray}></div>
                            <span>Повторные</span>
                          </div>
                        </>
                      )}
                      <div
                        className={styles.wrappIcon}
                        onClick={() => handleVariant(item.variant)}
                      >
                        <FullScreen />
                      </div>
                    </div>
                  </div>
                  <ChartBarIvideon
                    chartContainer={styles.chartContainer}
                    data={item.data || []}
                    label={item.label}
                    isLoading={isLoading}
                    size={{ width: "490px", height: "240px" }}
                    dataContentInfoCardCar={item.dataContentInfoCardCar!}
                    mainColor={item.mainColor}
                    secondaryColor={item.secondaryColor}
                    secondaryColor2={item.secondaryColor2}
                  />
                </div>
              );
            } else {
              return (
                <div className={styles.cardGraphSmall} key={item.variant}>
                  <div className={styles.cardTitleWrapper}>
                    <span className={styles.cardTitle}>{item.title}</span>
                    <div className={styles.itemTitleWrapper}>
                      <div
                        className={styles.wrappIcon}
                        onClick={() => handleVariant(item.variant)}
                      >
                        <FullScreen />
                      </div>
                    </div>
                  </div>
                  {item.variant === "age" && (
                    <div className={styles.wrapperLabelsCircle}>
                      {item.circleDataConfig?.map((cfg, i) => {
                        const allValues = item.circleDataConfig!.map(
                          (c) => c.value,
                        );
                        return (
                          <div key={i} className={styles.itemLabelCircle}>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                background: cfg.color,
                              }}
                            ></div>
                            <div>
                              {cfg.label}({getPercentages(allValues, cfg.value)}
                              )
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {item.variant === "emotion" && (
                    <div className={styles.wrapperLabelsCircleEmotion}>
                      {item.circleDataConfig?.map((cfg, i) => {
                        return (
                          <div key={i} className={styles.itemLabelCircle}>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                background: cfg.color,
                              }}
                            ></div>
                            <div>
                              {t(`analytica.${cfg.key}`)}{" "}
                              <span>{cfg.value}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <CircleChart
                    key={item.variant}
                    data={
                      item.circleDataConfig?.some((c) => c.value > 0)
                        ? [item.circleDataConfig!.map((c) => c.value)]
                        : []
                    }
                    label={item.circleDataConfig!.map((c) => c.label)}
                    circleColorList={item.circleDataConfig!.map((c) => c.color)}
                    chartContainer={styles.chartContainerChart}
                    isLoading={isLoading}
                    size={{ width: "490px", height: "300px" }}
                  />
                </div>
              );
            }
          })}
      </div>
    </>
  );
};
export default ChartsPeople;
